import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * query batch superbill by statement number
 */
export default async function queryBatchSuperbillByStatementNo(
  batchStatementNo: string,
) {
  const res = await fetchOrchidAPI(
    `/api/scheduler/v1/batch_superbill/${batchStatementNo}`,
    {
      method: "POST",
    },
  );
  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }
  return res.json();
}
